<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">To my children<br/>I love you all with everything that I am</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3d84dc38